export function checkIfIFrame() {
  return window.location !== window.parent.location;
}

export function checkIfStandalone() {
  return !checkIfIFrame();
}
